<template>
  <div class="p-front__content">
    <!-- {{ regSuccess }} -->
    <div class="p-signup" v-if="regSuccess == false" style="margin: 80px 0px;">
      <form
        class="p-signup__form"
        style="width: 80%;"
        method="POST"
        @submit="submitReg"
      >
        <!-- <img class="p-signin-a__form-heading" src="https://arnergy.com/logo.png" alt height="50px;"> -->
        <h4 class="p-signup__form-heading">Edit user</h4>
        <div class="p-signup__form-content">
          <b-alert variant="danger" dismissible :show="displayError">{{
            errorMessage
          }}</b-alert>
          <!-- {{regParams.noMail}} -->
          <div class="row">
            <div class="form-group col-md-12">
              <label for="p-signup-email">User Role</label>
              <!-- <el-form-item class="form-item" label="Owner"> -->
              <el-autocomplete
                style="width: 100%"
                id="user-role"
                :fetch-suggestions="searchRole"
                value-key="name"
                v-model="regParams.roleType"
                placeholder="Select Role"
                prefix-icon="el-icon-search"
                @select="checkSelRole"
              ></el-autocomplete>
            </div>
            <!-- <div class="form-group col-md-12">
              <label for="p-signup-email">User Role</label>
              <el-select
                style="width: 100%"
                v-model="regParams.roleType"
                id="user-role"
                placeholder="Select Role"
                @change="checkSelRole(regParams.roleType)"
              >
                <el-option
                  v-for="(single_role, key) in roleData"
                  :key="`role_${key}`"
                  :label="`${single_role}`"
                  :value="`${single_role.toLowerCase()}`"
                ></el-option>
              </el-select>
            </div> -->
            <div class="form-group col-md-12" v-show="isSectionManager">
              <label for="p-signup-email">Assign Device(s)</label>
              <el-select
                style="width: 100%"
                v-model="regParams.assignedDevices"
                id="user-role"
                filterable
                placeholder="Assign Device(s)"
                multiple
                @change="logTHis()"
              >
                <el-option
                  v-for="(installation, key) in installations"
                  :key="`installation_${key}`"
                  :label="`${installation.name} - ${installation.CID}`"
                  :value="`${installation.CID}`"
                ></el-option>
              </el-select>
            </div>
            <div class="form-group col-md-12">
              <label for="p-signup-email">Email</label>
              <input
                type="email"
                class="form-control form-control-lg"
                id="p-signup-email"
                v-model="regParams.email"
                placeholder="you@yourcompany.com"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="p-signup-first-name">First Name</label>
              <input
                type="text"
                class="form-control form-control-lg"
                id="p-signup-first-name"
                v-model="regParams.firstName"
                placeholder="First Name"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="p-signup-last-name">Last Name</label>
              <input
                type="text"
                class="form-control form-control-lg"
                id="p-signup-last-name"
                v-model="regParams.lastName"
                placeholder="Last Name"
              />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="p-signup-phone">Phone</label>
              <input
                type="phone-number"
                class="form-control form-control-lg"
                id="p-signup-phone"
                v-model="regParams.phoneNumber"
                placeholder="Phone Number"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="p-signup-gender">Gender</label>
              <el-select
                style="width: 100%"
                v-model="regParams.gender"
                id="p-signup-gender"
                placeholder="Choose Gender"
              >
                <el-option
                  v-for="single_gender in genderData"
                  :key="single_gender.id"
                  :label="single_gender.name"
                  :value="single_gender.id"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="p-signup-street_route">Home Address</label>
              <input
                type="address"
                class="form-control form-control-lg"
                id="p-signup-street_route"
                v-model="regParams.street_route"
                placeholder="Home Address"
              />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="p-signup-street_route">CC Emails</label>
              <input
                type="address"
                class="form-control form-control-lg"
                id="p-signup-street_route"
                v-model="regParams.ccEmails"
                placeholder="CC Email"
              />
            </div>
          </div>

          <!-- <div class="row">
            <div class="form-group col-md-12">
              <label for="p-signup-set-password">Set Password</label>
              <input
                type="password"
                class="form-control form-control-lg"
                id="p-signup-set-password"
                placeholder="Password "
                v-model="regParams.password"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="p-signup-repeat-password">Repeat Password</label>
              <input
                type="password"
                class="form-control form-control-lg"
                id="p-signup-repeat-password"
                placeholder="Repeat Password "
                v-model="regParams.cpassword"
              />
            </div>
          </div>-->

          <!-- <ul class="form-group p-signup__form-password-hints">
            <li>One lowercase character</li>
            <li>One number</li>
            <li>One uppercase character</li>
            <li>8 characters minimum</li>
          </ul>-->
          <!-- <div class="p-signup__form-links">
            <div class="p-signup__form-link">
              <input type="checkbox" name="checkbox" value="checked"> By creating an account, you agree to our
              <a href="#" class="link-info">terms and conditions</a>
            </div>
          </div>-->
          <hr />
          <div class="form-group col-md-12">
            <label for="p-signup-email">Send E-mail</label>
            <el-switch
              style="width: 100%"
              v-model="regParams.noMail"
              inactive-text="Send Email"
              active-text="Don't send Email"
            ></el-switch>
          </div>

          <div>
            <button
              :disabled="isLoading"
              type="submit"
              class="btn btn-info btn-block btn-lg p-signup__form-submit"
              @click="submitReg"
            >
              {{ isLoading ? "Loading..." : "Update User" }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { VueNotifications } from '../../main';
// import VueNotifications from 'vue-notifications';
import { mapGetters } from "vuex";
import { Autocomplete, Form, FormItem } from "element-ui";

export default {
  name: "new-user",
  data() {
    return {
      roleData: [],
      installations: [],
      regSuccess: false,
      isLoading: false,
      isSectionManager: false,
      regParams: {
        firstName: "",
        roleType: "".toLowerCase(),
        assignedDevices: [],
        lastName: "",
        dateOfBirth: new Date(),
        noMail: false,
        gender: null,
        phoneNumber: "",
        realm: "",
        username: "",
        email: "",
        street_route: "",
        password: "<%%>",
        cpassword: "<%%>",
        ccEmails: "",
        stateId: "",
        countryId: 1,
        lgaId: "null"
      },
      errors: {},
      displayError: false,
      errorMessage: "",
      selectedState: null,
      selectedLga: null,
      stateOptions: [
        {
          value: null,
          disabled: true,
          text: "Please select a state"
        }
      ],
      lgaOptions: [
        {
          value: null,
          disabled: true,
          text: "Please select LGA"
        }
      ],
      genderData: [
        {
          id: 1,
          name: "Male"
        },
        {
          id: 0,
          name: "Female"
        }
      ]
      // genderOptions: [
      //   {
      //     text: "Male",
      //     value: 1
      //   },
      //   {
      //     text: "Female",
      //     value: 0
      //   }
      // ]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  components: {
    "el-autocomplete": Autocomplete
  },
  computed: {
    // lgaOptions() {
    //   const state = this.selectedState;
    //   return state;
    // },
  },
  methods: {
    // updGender(val) {
    //   console.log(val);
    // },
    logTHis() {
      let ctx = this;
      ctx.$log({ assisgned: ctx.regParams.assignedDevices });
    },
    searchRole(queryString, cb) {
      const arrayItem = this.roleData;
      var results = queryString
        ? arrayItem.filter(item => {
            return (
              `${item.name.trim()}`
                .toLowerCase()
                .indexOf(queryString.toLowerCase()) > -1
            );
          })
        : arrayItem;

      cb(results);
    },
    toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    processMixedArray(mixedArray) {
      // Parse the input string to an array
      let parsedArray;
      try {
        parsedArray = JSON.parse(mixedArray);
      } catch (error) {
        throw new TypeError("Input must be a valid JSON string");
      }

      // Sanitize the array by ensuring proper string format
      let sanitizedArray = parsedArray.map(item => item.replace(/\\/g, ""));

      // Join the array elements into a single string
      let joinedString = sanitizedArray.join(",");

      // Check if the first element contains a JSON string
      if (joinedString.includes("[") && joinedString.includes("]")) {
        // Split the data into parts
        let parts = joinedString.split("],");
        let listPart = parts[0] + "]"; // Add back the closing bracket
        let valuesPart = parts[1]; // Remaining values

        // Parse the list part
        let arrayFromList = JSON.parse(listPart);

        // Parse the values part and convert to an array of strings
        let arrayFromValues = valuesPart
          .split(",")
          .map(item => item.trim().replace(/"/g, ""));

        // Combine both arrays
        let resultArray = arrayFromList.concat(arrayFromValues);

        return resultArray;
      } else {
        // If no JSON structure is detected, return the array as it is
        return parsedArray;
      }
    },
    checkSelRole() {
      let ctx = this;
      const role = ctx.regParams.roleType;
      // console.log(ctx.regParams.assignedDevices);
      ctx.isSectionManager = role === "section manager";
      if (ctx.isSectionManager === false) {
        ctx.regParams.assignedDevices = [];
      } else {
        ctx.regParams.assignedDevices = this.processMixedArray(
          ctx.regParams.assignedDevices
        );
        // ctx.regParams.assignedDevices = JSON.parse(
        //   ctx.regParams.assignedDevices
        // ).map(String);
      }
    },
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        // console.log(`${field}: ${value}`);
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          //   case "stateId":
          //     if (value === "null" || value === "") {
          //       errors[field] = "Please select a state.";
          //     }
          //     break;
          //   case "lgaId":
          //     if (value === "null" || value === "") {
          //       errors[field] = "Please select a local government.";
          //     }
          //     break;
          //   case "countryId":
          //     if (value === "null" || value === "") {
          //       errors[field] = "Please select a country.";
          //     }
          //     break;
          // case "gender":
          //   if (value === "null" || value === "") {
          //     errors[field] = "Gender cannot be empty.";
          //   }
          //   break;
          case "firstName":
            if (value === "null" || value === "") {
              errors[field] = "Firstname cannot be empty.";
              // console.log(this.errors)
            }
            break;
          case "lastName":
            if (value === "null" || value === "") {
              errors[field] = "Lastname cannot be empty.";
            }
            break;
          // case "username":
          //   if (value === "null" || value === "") {
          //     errors[field] = "Username cannot be empty.";
          //   }
          //   break;
          case "email":
            if (value === "null" || value === "") {
              errors[field] = "Email cannot be empty.";
            } else if (!this.isEmail(value)) {
              errors[field] = "Not a valid email.";
            }
            break;
          case "street_route":
            if (value === "null" || value === "") {
              errors[field] = "Address cannot be empty.";
            }
            break;
          case "phoneNumber":
            if (value === "null" || value === "") {
              errors[field] = "Phone cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      this.errors = errors;
      // console.log(this.errors);
    },
    submitReg(e) {
      e.preventDefault();
      this.validateReg();
      var container = this;
      var errorLength = Object.keys(this.errors).length;
      if (container.regParams.roleType === "section manager") {
        if (container.regParams.assignedDevices.length < 1) {
          this.displayError = true;
          setTimeout(() => {
            this.displayError = false;
          }, 3000);
          var errorMsg = "Assign Device(s) is required";
          this.errorMessage = "Assign Device(s) is required";
          // console.log()
          this.showErrorMsg({
            message: errorMsg
          });
          return;
        }
      }
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({
          message: errorMsg
        });
      } else {
        var str = JSON.stringify(this.regParams);
        const tempReg = JSON.parse(str);
        tempReg["assignedDevices"] = JSON.stringify(tempReg["assignedDevices"]);
        delete tempReg["cpassword"];
        // tempReg["username"] = tempReg["email"];
        // if(tempReg["assignedDevices"]){
        //   tempReg["assignedDevices"] = JSON.stringify(tempReg["assignedDevices"]);
        // }
        if (tempReg["installations"]) {
          delete tempReg["installations"];
        }
        // console.log({ tempReg });
        // return;

        this.toggleIsLoading();
        const HTTP = this.$httpUtils.instance;
        let url = `/users/${this.userId}`;
        HTTP.patch(url, tempReg)
          .then(response => {
            this.toggleIsLoading();
            container.regSuccess = true;
            this.showSuccessMsg({
              message: "User Updated!"
            });
            this.$router.push({ path: "/users/list" });
          })
          .catch(error => {
            this.toggleIsLoading();
            if (error.response.data.error.details) {
              var errorMsg = error.response.data.error.details.messages;
              var errTemp = [];
              var keyHooks = Object.keys(errorMsg);
              Object.values(errorMsg).map((x, index) => {
                errTemp[index] = keyHooks[index] + " " + x[0];
                // console.log(index);
              });
              // console.log("error", errTemp);
              errTemp = Object.values(errTemp).join("<br>");
              this.showErrorMsg({
                message: errTemp
              });
            } else {
              this.showErrorMsg({
                message: error.response.data.error.message
              });
            }
          });
      }
    },
    fetchStates() {
      const HTTP = this.$httpUtils.instance;
      const url = "/states";
      HTTP.get(url)
        .then(response => {
          // console.log(JSON.stringify(response))
          const statesList = response.data;
          let str = JSON.stringify(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          let tempState = JSON.parse(str);
          tempState = tempState.map(x => {
            return {
              ...x,
              text: x.text[0].toUpperCase() + x.text.substring(1)
            };
          });
          tempState.unshift({
            value: null,
            disabled: true,
            text: "Please select a state"
          });
          this.stateOptions = tempState;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchLgas(state) {
      if (state !== null) {
        const context = this;
        const HTTP = this.$httpUtils.instance;
        const url = `/states/${state}/lgas`;
        HTTP.get(url)
          .then(response => {
            const statesList = response.data;
            let str = JSON.stringify(statesList);
            str = str.replace(/id/g, "value");
            str = str.replace(/name/g, "text");
            let tempLga = JSON.parse(str);
            tempLga = tempLga.map(x => {
              return {
                ...x,
                text: x.text[0].toUpperCase() + x.text.substring(1)
              };
            });
            tempLga.unshift({
              value: null,
              disabled: true,
              text: "Please select LGA"
            });
            context.lgaOptions = tempLga;
          })
          .catch(error => {
            console.log("error", error);
          });
      }
    },
    fetchInstallations() {
      let ctx = this;
      const HTTP = this.$httpUtils.instance;
      const url = "/installations/";
      let filter = `?filter[where][CID][neq]=null`;
      HTTP.get(url + filter)
        .then(response => {
          ctx.installations = response.data;
          //  this.$store.commit("setRole", self.roleData);
          //this.setRole(self.roleData);
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchUserRoles() {
      //    fetchPreviledges() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      let url = "/roles";
      HTTP.get(url)
        .then(response => {
          container.roleData = response.data;
        })
        .catch(error => {
          console.log("error", error);
        });
      // },
    }
  },
  mounted() {
    let ctx = this;
    ctx.userId = ctx.$route.params.userId * 1;

    let user = ctx.$route.query.user;
    this.regParams = user;
    this.fetchStates();
    this.fetchUserRoles();
    ctx.fetchInstallations();
    this.checkSelRole();
  }
};
</script>

<style scoped>
h4.p-signup__form-heading {
  font-weight: 600;
  color: #6a707e;
  border: none;
}

#state_dd {
  width: 100%;
}

#state_dd #state_dd__BV_toggle_ {
  width: 100% !important;
}

#reg_success {
  position: absolute;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0px;
  z-index: 999;
}

.form-group label {
  color: #424242;
}
.p-signin-a__form-heading {
  margin: 50px 175px;
  border: none;
}
input[type="email"] {
  /* background-image: url("../../assets/img/mail.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}

.p-signup__form-link:last-child {
  margin-bottom: 20px;
}
input[type="text"] {
  /* background-image: url("../../assets/img/profile2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="phone-number"] {
  /* background-image: url("../../assets/img/smartphone-call.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="address"] {
  /* background-image: url("../../assets/img/placeholder.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
select {
  background-color: #ebeff2 !important;
  text-indent: 0px;
}
input[type="password"] {
  /* background-image: url("../../assets/img/key2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="checkbox"] {
  height: 0rem;
  margin-right: 20px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/edit-user.vue